import AppMagma from '../app-magma'
import AppProjectSlideshow from '../app-project-slideshow'
import AppFav from '../app-fav'
import AppReadMore from '../app-read-more'
import CoreParseImg from '../core-parse-img'
import CoreVideoPlayer from '../core-video-player'
import CoreFetch from '../core-fetch'

export default
{
    components:
    {
        AppFav,
        AppMagma,
        AppProjectSlideshow,
        AppReadMore,
        CoreFetch,
        CoreParseImg,
        CoreVideoPlayer
    },

    props:
    {
        content: { type: Object, default: null }
    },

    data()
    {
        return {
            readmoreHeight: 0,
            activeSlideshowContent: null,
            isModalActive: false,
            hasGallery: false,
            activeSlideIndex: 0,

            instagram: [],
            tags: [],
            otherProjects: null
        }
    },

    created()
    {
        this._isTimerActive = false

        for(let i = 0; i < this.content.strates.length; i++)
        {
            if(this.content.strates[i].acf_fc_layout === 'galerie_images')
            {
                this.hasGallery = true
                this._galleryIndex = i
            }
        }

        this._isProjetsDataLoaded = false

        this._tmpTags = []
        this.eventHub.$on('window:resize', this.onResize)
        this.eventHub.$on('window:tick', this.onTick)
    },

    mounted()
    {
        this.$informations = this.$el.querySelector('.js-informations')
        this.$mobileInformations = this.$el.querySelectorAll('.js-mobile-informations')

        if(this.hasGallery)
        {
            this.$mobileInformations[this._galleryIndex].innerHTML = this.$informations.innerHTML
        }

        for(let i = 0; i <= this.content.strates.length; i++)
        {
            if(this.content.strates[i] && this.content.strates[i].acf_fc_layout === 'instagram')
            {
                for(let j = 0; j < this.content.strates[i].posts.length; j++)
                {
                   this.instagram.push( 'https://instagram.com' + this.content.strates[i].posts[j].post_content.match(/https:\/\/www.instagram.com(.*)\/["']/)[1] )
                }
            }
        }

        this.onResize()

        this.$emit('page:ready')

        this.$el.classList.add('is-page-ready')
    },

    destroyed()
    {
        this.eventHub.$off('window:resize', this.onResize)
        this.eventHub.$off('window:tick', this.onTick)
    },

    methods:
    {
        onResize()
        {
            // if(this.$readmoreRef)
            // {
            //     if(this.$root.window.width < 770)
            //     {
            //         this.readmoreHeight = 200
            //     }
            //     else
            //     {
            //         this.readmoreHeight = this.$readmoreRef.offsetHeight - 70
            //     }


            //     // console.log('oui', this.readmoreHeight)
            // }
        },

        onToggleModal(index, content)
        {
            this.isModalActive = !this.isModalActive
            this.eventHub.$emit('toggle:modalProject')

            if(this.isModalActive)
            {
                this.activeSlideshowContent = content
                this.activeSlideIndex = index
            }
        },

        onToggleTag(event, tag)
        {
            const el = event.currentTarget
            this.$el.classList.add('is-filtering')

            if(this._tmpTags.includes(tag.slug))
            {
                el.classList.remove('is-active')
                const index = this._tmpTags.indexOf(tag.slug)
                this._tmpTags.splice(index, 1)
            }
            else
            {
                el.classList.add('is-active')
                this._tmpTags.push(tag.slug)
            }

            // this.tags = null

            this.$nextTick(() =>
            {
                this.tags = this._tmpTags
            })

        },


        onProjectsLoaded(resp)
        {
            let tmpArray = []
            this.otherProjects = null

            for(let i = 0; i < resp.length; i++)
            {
                if(resp[i].post_name !== this.content.post_name)
                {
                    tmpArray.push(resp[i])
                }
            }

            this.$nextTick(() =>
            {
                this.otherProjects = tmpArray

                if(this.otherProjects.length > 0)
                {
                    this._isProjetsDataLoaded = true
                }
            })

            setTimeout(() =>
            {
                this.$el.classList.remove('is-filtering')
            }, 500)
        },

        onTick()
        {
            if(this._isProjetsDataLoaded)
            {
                if((this.$root.scrollTop + this.$root.window.height) >= this.$el.offsetHeight)
                {

                    if(!this._isTimerActive)
                    {
                        this._isTimerActive = true
                        this.$el.classList.add('is-timer-active')

                        this._timer = setTimeout(() =>
                        {
                            this.eventHub.$emit('display:subcat', this.content.categories[0].slug, 'projects', true)
                        }, 1800)
                    }
                }
                else
                {
                    if(this._isTimerActive)
                    {
                        this._isTimerActive = false
                        this.$el.classList.remove('is-timer-active')
                        clearTimeout(this._timer)
                    }
                }
            }
        },

        deplaceArrayElement(arr, old_index, new_index)
        {
            if(new_index >= arr.length)
            {
                let k = new_index - arr.length + 1


                while (k--)
                {
                    arr.push(undefined)
                }
            }

            arr.splice(new_index, 0, arr.splice(old_index, 1)[0])

            // return arr; // for testing
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-page-project/script.js